import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import Utils from '@utils/utils';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { DatePipe } from '@angular/common';
import { Perfil } from 'src/app/common/interfaces/perfil.interface';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import Swal from 'sweetalert2';
import { environment } from '@env/environment';
import { ToolsService } from '@services/varios/tools.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-perfiles',
  templateUrl: './perfiles.component.html',
  styleUrls: ['./perfiles.component.scss'],
  providers: [DatePipe] // Proveedor de DatePipe
})

export class PerfilesComponent implements OnInit, AfterViewInit {
  
  public perfiles: Perfil[] = [];
  public perfil: Perfil = {} as Perfil;
  selectedColumn: string = 'todas'; // Columna seleccionada en el mat-select
  filterValue: string = ''; // Valor del input de filtro
  public dataPerfiles: MatTableDataSource<Perfil> = {} as MatTableDataSource<Perfil>;

  filtros = [
    { value: 'nombrePerfil', text: 'PERFIL' }
  ];

  filtrosExportacion = [
    { value: 'nombrePerfil', text: 'PERFIL' },
    { value: 'usarDatosNacionales', text: 'USAR DATOS NACIONALES'}
  ];

  displayedColumns: string[] = [
    'ordenJerarquia',
    'nombrePerfil',
    'usarDatosNacionales',
    'action'
  ];

  constructor(private readonly _liveAnnouncer: LiveAnnouncer,private readonly matPaginatorIntl: MatPaginatorIntl, private readonly perfilService: PerfilesService, private readonly spinnerService: SpinnerService,private readonly toolsService: ToolsService) {
    this.dataPerfiles = new MatTableDataSource(this.perfiles);
    this.matPaginatorIntl.itemsPerPageLabel = 'Elementos por página';   
    this.matPaginatorIntl.lastPageLabel = 'Última Página';
    this.matPaginatorIntl.nextPageLabel = 'Próxima Página';
    this.matPaginatorIntl.firstPageLabel = 'Primera Página';
    this.matPaginatorIntl.previousPageLabel = 'Página Anterior';
    this.matPaginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
       if (length === 0 || pageSize === 0) {
         return `0 de ${length}`;
       }
       length = Math.max(length, 0);
 
       const startIndex = page * pageSize;
       const endIndex = startIndex < length ?
         Math.min(startIndex + pageSize, length) :
         startIndex + pageSize;
       return `${startIndex + 1} - ${endIndex} de ${length}`;
     };
  }

  @ViewChild(MatTable, { static: true }) table: MatTable<any> = Object.create(this.perfiles);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @ViewChild(MatSort) sort: MatSort = new MatSort();

  ngAfterViewInit() {
    this.dataPerfiles.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  async ngOnInit(): Promise<void> {
    this.refresh();
  }

  async refresh(){
    let spinnerRef = this.spinnerService.start();

    let listPerfiles = await this.perfilService.getPerfilesService();

    listPerfiles.forEach(x =>{
      let entity:Perfil = {} as Perfil;
      entity.idPerfil = x.idPerfil;
      entity.idSistema = x.idSistema;
      entity.nombrePerfil = x.nombrePerfil;
      entity.ordenJerarquia = x.ordenJerarquia;
      entity.usarDatosNacionales = x.usarDatosNacionales;
      this.perfiles.push(entity);
    });

    this.dataPerfiles = new MatTableDataSource(this.perfiles);
    this.dataPerfiles.paginator = this.paginator;
    this.dataPerfiles.sort = this.sort;
    this.applyFilter();

    this.spinnerService.stop(spinnerRef);
  }

  async openDialog(perfil:any): Promise<void> {
    let texto= '';
    let idPerfil = '';
    let orden:number = 0;
    let usar:boolean = false;
    let vari = '';

    if (perfil == null) {
      vari = '';
      texto = 'Crear';
      orden = this.perfiles.length + 1;
    } else {
      texto = 'Actualizar';
      idPerfil = perfil.idPerfil;
      vari = perfil.nombrePerfil;
      orden = perfil.ordenJerarquia;
      usar = perfil.usarDatosNacionales;
    }

    let usartext = usar? 'checked':'';

    await Swal.fire({
      title: texto + " Perfil",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: texto,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#e23234',
      cancelButtonColor: '#7f7f7f',
      html: `
        <label></label><input id="swal-input1" class="swal2-input" value="` + vari +`" placeholder="Ingrese Perfil" autocomplete="off"><br>
        <input id="swal-input2" type="checkbox" style="width: 20px; height: 20px;" ` + usartext +`><label>Usar Datos Nacionales</label>
      `,
      focusConfirm: false,
      didOpen: () => {
        const inputElement = document.getElementById('swal-input1') as HTMLInputElement;
        if (inputElement) {
          inputElement.addEventListener('input', () => {
            inputElement.value = inputElement.value.toUpperCase(); // Convierte a mayúsculas en tiempo real
          });
        }
      },
      preConfirm: async () => {
        const perfilNomPre = document.getElementById("swal-input1")  as HTMLInputElement;
        const checkPre = document.getElementById("swal-input2") as HTMLInputElement;
        let perfilNombreValue = perfilNomPre.value;
        let checkValue = checkPre.checked;

        if (!perfilNombreValue) {
          Swal.showValidationMessage('<i class="fa fa-info-circle"></i> debe ingresar un perfil')
        } else if (perfilNombreValue != vari || usar != checkValue) {
          vari = perfilNombreValue;
          let perfilSend:Perfil = {} as Perfil;
          perfilSend.idPerfil = idPerfil;
          perfilSend.idSistema = environment.idSistema
          perfilSend.nombrePerfil = perfilNombreValue;
          perfilSend.ordenJerarquia = orden;
          perfilSend.usarDatosNacionales = checkValue;

          let respuesta:Perfil = await this.perfilService.addOrUpdatePerfil(perfilSend);

          perfilSend.idPerfil = respuesta.idPerfil;

          if (respuesta.nombrePerfil != '') {
            if (idPerfil == '') {
              this.perfiles.push(perfilSend);
            } else {
              this.perfiles.filter(x=>x.idPerfil == idPerfil)[0].nombrePerfil = respuesta.nombrePerfil; 
            }

            await this.toolsService.okMensaje('Operación realizada exitosamente!');

          } else {
            await this.toolsService.errorMensaje('Error en guardado!');
          }
        }
      }
    });

    this.perfiles = [];
    this.refresh();
    
  }

  async deletePerfil(perfil:any): Promise<void> {
    
    let resultado = await this.toolsService.confirmaMensaje('Eliminar perfil','Esta seguro que desea eliminar el perfil: ' + perfil.nombrePerfil);

    if (resultado) {
      let resOp= await this.perfilService.deletePerfil(perfil);
      if (resOp != '') {
        if (resOp == 'ok') {
          this.toolsService.okMensaje('Operación realizada exitosamente');
        } else {
          this.toolsService.errorMensaje(resOp, true);
        }
      } else {
        this.toolsService.errorMensaje('Error en eliminación');
      }

      this.perfiles = [];
      this.refresh();
    }
  }


  exportToExcel() {
    let spinnerRef = this.spinnerService.start();

    const excelBlob = Utils.exportToExcelSimple(this.dataPerfiles.filteredData, this.filtrosExportacion, 'PERFILES');
    const now = new Date();
    const fileName = `Perfiles_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}.xlsx`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(excelBlob);
    link.download = fileName;
    link.click();

    /*
    Para subir a un servicio ejemplo
    const now = new Date();
    const fileName = `Empaques_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}.xlsx`;

    let fileUP = new File([excelBlob], fileName, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //await this.cargaArchivo(fileUP);
    */

    this.spinnerService.stop(spinnerRef);
  }

  applyFilter(): void {
    const filterValueLower = Utils.removeAccentsOfString(this.filterValue).trim().toLowerCase();
   
    if (this.selectedColumn == 'todas') {
      this.clearFilter();
    } else {
      // Aplicar el filtro a la fuente de datos
      this.dataPerfiles.filterPredicate = (data: any, filter: string) => {
        let texto: string = data[this.selectedColumn].toString();
        if (texto.includes('00:00:00')) {
          texto = texto.substring(0,10);  
          const [anio, mes, dia] = texto.split('-');     
          texto = `${dia}/${mes}/${anio}`;
        }
        
        let columnValue = texto.replace('true','SI').replace('false','NO').toLowerCase();
        return Utils.removeAccentsOfString(columnValue).includes(Utils.removeAccentsOfString(filter));
      };
    }

    // Forzar a que la fuente de datos filtre nuevamente
    this.dataPerfiles.filter = filterValueLower;
  }

  clearFilter() {
    // Reset the filterPredicate to its default value
    this.dataPerfiles.filterPredicate = this.defaultFilterPredicate;
    this.dataPerfiles.filter = '';
  }

  // Default filter predicate function
  defaultFilterPredicate(data: any, filter: string): boolean {
    const dataStr = Object.keys(data).reduce((currentTerm, key) => {
      // Handle cases where data[key] is null/undefined
      if (data[key] !== null && data[key] !== undefined) {
        let texto: string = data[key].toString();
        if (texto.includes('00:00:00')) {
          texto = texto.substring(0,10);  
          const [anio, mes, dia] = texto.split('-');     
          texto = `${dia}/${mes}/${anio}`;
        }
        return currentTerm + texto.replace('true','SI').replace('false','NO').toLowerCase();
      } else {
        return currentTerm;
      }
    }, '');

    // Transform the filter by converting it to lowercase and removing whitespace
    const transformedFilter = filter.trim().toLowerCase();

    return Utils.removeAccentsOfString(dataStr).indexOf(Utils.removeAccentsOfString(transformedFilter)) !== -1;
  }

  convertirFecha(fechaString: string): string {
    const [anio, mes, dia] = fechaString.split('-'); // Dividir la cadena por guiones
    return `${dia}/${mes}/${anio}`; // Devolver la fecha en formato 'dd/MM/yyyy'
  }

  dropTable(event: CdkDragDrop<Perfil[]>) {
    if (event.currentIndex > 2) {
      const prevIndex = this.dataPerfiles.data.findIndex((d) => d === event.item.data);

      moveItemInArray(this.dataPerfiles.data, prevIndex, event.currentIndex);
      
      this.table.renderRows();

      for (let index = 3; index < this.perfiles.length; index++) {
        const element = this.perfiles[index];
        element.ordenJerarquia = index;
      }   
    }
  }

  async guardarJerarquia() {
    let resultado = await this.toolsService.confirmaMensaje('Actualizar Jerarquía', 'Está seguro que desea actualizar la jerarquía de los perfiles');

    if (resultado) {
      let spinnerRef = this.spinnerService.start();

      this.perfiles.forEach(async element => {
        await this.perfilService.addOrUpdatePerfil(element);
      });
      
      this.spinnerService.stop(spinnerRef);
    }
  }
}